import { useEffect, useState, type FormEvent } from 'react';
import { PhoneCall, Plus } from 'lucide-react';
import type { GrandpaCalls } from '../types';

interface GrandpaCallCounterProps {
  grandpaCalls: GrandpaCalls;
  isAdmin: boolean;
  isBusy: boolean;
  onIncrement: () => Promise<void>;
  onSetCount: (count: number) => Promise<void>;
}

export function GrandpaCallCounter({ grandpaCalls, isAdmin, isBusy, onIncrement, onSetCount }: GrandpaCallCounterProps) {
  const [adminCount, setAdminCount] = useState(String(grandpaCalls.count));

  useEffect(() => setAdminCount(String(grandpaCalls.count)), [grandpaCalls.count]);

  async function handleSetCount(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    await onSetCount(Number(adminCount));
  }

  return (
    <article className="grandpa-call-card" aria-labelledby="grandpa-call-title">
      <span className="grandpa-call-card__icon"><PhoneCall size={21} aria-hidden="true" /></span>
      <div className="grandpa-call-card__content">
        <h2 id="grandpa-call-title">Chiamate Nonno</h2>
        <p aria-live="polite"><strong>{grandpaCalls.count}</strong> {grandpaCalls.count === 1 ? 'chiamata oggi' : 'chiamate oggi'}</p>
      </div>
      <button className="button button--primary grandpa-call-card__increment" type="button" disabled={isBusy} onClick={() => void onIncrement()}>
        <Plus size={18} aria-hidden="true" /> 1 chiamata
      </button>
      {isAdmin && (
        <details className="grandpa-call-card__admin">
          <summary>Imposta manualmente</summary>
          <form className="counter-admin-form" onSubmit={handleSetCount}>
            <label className="field">
              <span>Numero chiamate di oggi</span>
              <input
                type="number"
                inputMode="numeric"
                min="0"
                max="9999"
                value={adminCount}
                onChange={(event) => setAdminCount(event.target.value)}
              />
            </label>
            <button className="button button--secondary" type="submit" disabled={isBusy || !adminCount || Number(adminCount) === grandpaCalls.count}>Imposta</button>
          </form>
        </details>
      )}
    </article>
  );
}
